// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global styling for adminstrator pages */

/*#region Recommendations*/

#admin-recommendations {
  width: 100vw;
  margin-top: 13px;
}

.search-filter-bar {
  height: 40px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.dropdown-filter {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 20px;
  font-size: 15px;
  font-family: Calibri;
}

.skill-dropdown {
  width: 173px;
  display: flex;
  align-items: center;

  > .MuiFormControl-root {
    > .MuiOutlinedInput-root {
      > .MuiSelect-select {
        padding-left: 6px;
        align-content: center;
        border-color: #6e6e6e !important;
        height: 36px;
        border-radius: 10px !important;
      }
    }
  }
}

.skill-role-table {
  width: 100vw;
  box-sizing: border-box;
}

.column-header-title {
  font-weight: 800;
  font-size: 15px;

  &.left-col {
    margin-left: 10px;
  }

  &.first {
    margin-left: 20px;
  }
}

.first-column-header {
  .MuiDataGrid-iconButtonContainer {
    visibility: 'visible';
  }

  .MuiDataGrid-sortIcon {
    opacity: 'inherit !important';
  }
}

.MuiTooltip-root {
  display: none;
}

.MuiToolbar-root {
  padding: 0px !important;
}

.MuiTablePagination-selectLabel {
  display: none !important;
}

.MuiDataGrid-root {
  /* Remove possible gap below DataGrid content */
  .MuiDataGrid-virtualScrollerContent {
    line-height: normal;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }
  .MuiDataGrid-row:last-child {
    margin-bottom: 0 !important;
  }
  > .MuiInputBase-root,
  .MuiInputBase-colorPrimary:not(.step-3) {
    display: none !important;
  }

  /* Ensure consistent box model for DataGrid virtual scroller and rows */
  .MuiDataGrid-virtualScrollerContent,
  .MuiDataGrid-row {
    box-sizing: border-box;
  }
}
/*#endregion Recommendations*/

/*#region Overdue Banner*/
#overdue-banner-react {
  width: 100%;
  background-color: whitesmoke;
  border-bottom: 1px solid black;
  font-family: Calibri, sans-serif;
}

#overdue-banner-react .warning-icon {
  color: white;
  padding-left: 6px;
}

#overdue-banner-react p {
  font-weight: bold;
  padding-left: 20px;
  font-size: 15px;
  line-height: 17.15px;
  padding-bottom: 5px;
}

#overdue-banner-react span {
  font-weight: 400;
}

#overdue-banner-react table {
  margin-left: 40px;
  margin-bottom: 20px;
  font-size: 15px;
  line-height: 17.15px;
}

#overdue-banner-react table #header {
  border-bottom: 1px solid black;
}

#overdue-banner-react table th,
#overdue-banner-react table td {
  padding-top: 5px;
  padding-bottom: 5px;
}

#overdue-banner-react table .padding-right {
  padding-right: 80px;
}

#overdue-banner-react h3 {
  border-bottom: 1px solid black;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 0px;
  text-align: center;
  background-color: rgb(231, 68, 68);
  color: white;
  font-size: 28px;
}

#overdue-banner-react #error {
  margin-left: 20px;
  margin-right: 20px;
}

#overdue-banner-react #overdue-total {
  border-top-style: solid;
  border-top-width: 1px;
  font-weight: bold;
}

#overdue-banner-react .invoice-pdf-button {
  border: none;
  text-decoration: underline;
  background: none;
  font-size: 14px;
  color: #505050;
  padding: 0px;
}

/*#endregion Overdue Banner*/

/* #custom data grid */

#admin-content-table .third-column-header.MuiDataGrid-columnHeader,
#admin-content-table .third-column-header.MuiDataGrid-cell {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.admin-datagrid {
  .MuiDataGrid-cell:last-of-type {
    display: flex;
    flex-wrap: wrap;
    align-content: baseline !important;
    margin: 0.2rem 0 !important;
  }

  .MuiDataGrid-columnHeaderTitleContainerContent {
    margin-left: inherit;
  }

  .column-header-title {
    &.first {
      margin-left: 0px;
    }

    &.left-col {
      margin-left: 0px;
    }
  }

  .MuiTouchRipple-root {
    background-color: transparent;
  }

  .MuiDataGrid-columnHeaderTitleContainerContent .MuiCheckbox-root {
    padding-top: 0;
    background-color: inherit;
  }

  .action-buttons {
    margin: 0.2rem 5px 0.2rem 0 !important;
    min-width: 15px !important;
    width: 25px;
    height: 23px;
    padding: 0px;
    display: flex;

    &:first-child {
      width: 47px;
    }

    &:last-child {
      margin-right: 0px;
    }
    .MuiListItemIcon-root {
      height: inherit;
      display: flex;
      align-items: center;

      > svg {
        height: 125%;
        width: 100%;
      }
    }

    &.pencil {
      padding: 0px 0px 1px 2px;
      > svg {
        fill: rgb(255, 255, 255);
        stroke: rgb(46, 46, 46);
        height: 28.75px;
        width: 36px;
      }
    }

    &.eye {
      padding: 1px 0px 0px 0px;
      svg {
        height: 95%;
      }
    }

    &.reprocess {
      padding: 1px 0px 0px 0px;

      svg {
        height: 21.84px;
        width: 36px;
        stroke: #2e2e2e;
        stroke-linecap: round;
        stroke-miterlimit: 10;
        stroke-width: 15px;
      }
    }

    &.deactivate {
      padding: 1px 0px 0px 0px;

      svg {
        height: 18px;
        width: 36px;
      }
    }
  }

  input[type='checkbox'] {
    margin: 0 !important;

    &.focus {
      outline: 2px solid transparent;
      outline-offset: 2px;
      --tw-ring-inset: var(--tw-empty, /*!*/ /*!*/);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-color: theme('colors.blue.600', colors.blue[600]);
      --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
        var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-shadow: \`var(--tw-ring-inset) 0 0 0
        calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
      box-shadow:
        var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      border-color: none;
    }
  }

  .MuiDataGrid-row {
    &.top-aligned-row {
      .MuiDataGrid-cell {
        align-self: flex-start !important;

        .MuiCheckbox-root {
          margin-top: 4px !important;
          align-self: flex-start !important;
          input[type='checkbox'] {
            top: 0px !important;
          }
        }
      }
    }
  }
}
/* #end data grid */

/* # begin admin content table */
#admin-content-table {
  width: 100%;
  min-width: 0;

  > div {
    width: 100%;
    min-width: 0;
  }

  .MuiDataGrid-root {
    width: 100%;
    min-width: 0;
  }

  .MuiDataGrid-cell {
    overflow: hidden;

    > * {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%;
    }
  }

  .MuiDataGrid-columnHeader {
    overflow: hidden;
  }
}

#admin-content-table .action-buttons:last-child {
  margin-right: 0px !important;
}
/* #end admin content table */

/* begin people group modal */
#root:has(.admin-datagrid) ~ div[role='presentation'] {
  #copy-people-group-modal-table {
    .MuiDataGrid-scrollbarFiller--header {
      background-color: #f7fcff;
    }
    .MuiDataGrid-filler {
      height: 30px !important ;
    }
    .MuiDataGrid-container--top {
      .MuiDataGrid-filler {
        margin-top: -2px;
        background-color: #f7fcff;
        height: var(--DataGrid-topContainerHeight) !important;
      }

      .MuiDataGrid-scrollbarFiller--header {
        margin-top: -2px;
      }
    }

    .MuiDataGrid-columnHeader {
      border-top: none !important;
      margin-top: -2px !important;

      .column-header-title {
        margin-left: 12px !important;
        .required {
          color: red;
          padding-left: 2px;
        }
      }
    }

    .MuiDataGrid-virtualScrollerContent {
      /* Removed explicit height to fix 2px gap issue. Let content determine height. */

      div[role='row'] {
        > div[role='gridcell']:nth-of-type(2) {
          margin-left: 12px;
          padding-right: 10px;
        }
        div[role='gridcell']:nth-last-of-type(1) {
          margin-right: 12px;
        }
      }
    }
    .MuiDataGrid-virtualScroller {
      /* uses the height of the modal - header height - 4px padding */
      min-height: calc((450px - var(--DataGrid-headerHeight)) - 4px);
    }

    .MuiDataGrid-main {
      height: inherit;

      + .MuiBox-root {
        padding: 4px !important;
        height: var(--DataGrid-topContainerHeight) !important;

        .MuiTablePagination-root {
          padding: 2px 0;
          margin-top: -4px;
        }
        .MuiTablePagination-actions {
          margin-left: 9px;
        }
      }
    }

    .MuiDataGrid-cell--editing,
    .MuiDataGrid-cell--editable {
      outline: none;
      box-shadow: none;
    }

    .gridInteractionField {
      width: 100% !important;
      border-radius: 10px 10px;

      &:hover {
        background-color: #ffffff !important;
      }
    }

    .MuiFormControl-root {
      margin: 0 0 !important;
      font-family: Calibri, sans-serif;
      textarea {
        font-family: inherit !important;
      }
    }

    .MuiInputBase-root {
      display: unset !important;
      font-size: 14px;
      font-family: inherit !important;
      padding: 11px 10px;

      & fieldset {
        top: 0;
        & legend {
          display: none !important;
        }
      }
    }

    /* FireFox overrides */
    @-moz-document url-prefix() {
      .MuiDataGrid-row {
        width: calc(
          100% - var(--DataGrid-scrollbarSize) - var(--DataGrid-scrollbarSize) -
            20px
        );
      }

      .gridInteractionField {
        width: 98% !important;
      }
      .MuiDataGrid-scrollbar--vertical {
        margin-top: 1px;
      }
    }

    .MuiDataGrid-main + .MuiBox-root {
      height: auto !important;
      min-height: 65px !important;
    }
  }
}

/* end people group modal */

/* #begin common for tabs admin recs and admin rules  */
#root:has(
    #admin-rules-main-container,
    #admin-recommendations,
    .input-wrapper #people-group-audience-modal-table,
    #rule-preview-modal-table
  )
  ~ div[role='presentation'] {
  li.MuiMenuItem-root[role='option'] {
    font-family: Calibri, sans-serif;
    &:focus,
    &:hover {
      background-color: #f7fcff !important;
    }
  }
  .MuiAutocomplete-option[aria-selected='true'] {
    background-color: #f7fcff !important;
  }

  .MuiDataGrid-columnHeader {
    background-color: #f7fcff !important;
  }

  #people-group-audience-modal-table,
  #rule-preview-modal-table {
    tr th.MuiTableCell-root,
    .MuiTableRow-root:hover {
      background-color: #f7fcff !important;
    }
  }
}
/* #end common for tabs admin recs and admin rules  */

/* begin copy rule modal */
#copy-rules-modal-table {
  position: relative;
  overflow: unset;

  .MuiDataGrid-scrollbarFiller--header {
    background-color: #f7fcff;
    margin-top: -2px;
  }

  .MuiDataGrid-filler {
    height: 30px !important;
  }

  .MuiDataGrid-container--top {
    .MuiDataGrid-filler {
      margin-top: -2px;
      background-color: #f7fcff;
      height: var(--DataGrid-topContainerHeight) !important;
    }
  }
  .MuiDataGrid-cell {
    align-self: center !important;
  }
  .MuiDataGrid-columnHeader {
    background-color: #f7fcff !important;
    border-top: none !important;
    font-weight: bold !important;

    .column-header-title {
      margin-left: 12px !important;
      font-size: 15px;

      .required {
        color: red;
        padding-left: 2px;
      }
    }
  }

  .MuiDataGrid-columnHeaderTitleContainerContent {
    white-space: normal !important;
    overflow: visible !important;
  }

  .MuiDataGrid-virtualScrollerContent {
    /* Removed explicit height to fix 2px gap issue. Let content determine height. */

    div[role='row'] {
      > div[role='gridcell']:nth-of-type(1) {
        padding-left: 12px;
      }

      > div[role='gridcell']:nth-of-type(2) {
        padding-left: 12px;
        padding-right: 12px;
      }

      > div[role='gridcell']:nth-of-type(3),
      > div[role='gridcell']:nth-of-type(4) {
        padding-left: 12px;
        padding-right: 12px;
      }

      > div[role='gridcell']:nth-of-type(5) {
        padding-left: 12px;
      }
    }

    .MuiDataGrid-row {
      width: calc(100% - var(--DataGrid-scrollbarSize)) !important;
    }
  }

  .MuiDataGrid-virtualScroller {
    /* uses the height of the modal - header height - 4px padding */
    min-height: calc((448px - var(--DataGrid-headerHeight)) - 0px);
  }
  .MuiDataGrid-cell--editing,
  .MuiDataGrid-cell--editable {
    outline: none;
    box-shadow: none;
    background-color: transparent;
  }
  .MuiDataGrid-main {
    height: inherit;
    overflow: visible !important;

    + .MuiBox-root {
      padding: 4px !important;
      height: var(--DataGrid-topContainerHeight) !important;

      .MuiTablePagination-root {
        padding: 2px 0;
        margin-top: -4px;
      }
      .MuiTablePagination-actions {
        margin-left: 9px;
      }
    }
  }

  .MuiInputBase-root textarea {
    white-space: pre-wrap;
    word-break: break-word;
    padding: 0px;
    font-size: 14px;
    resize: none;
    overflow: hidden;
    height: auto;
  }

  .MuiFormControl-root {
    margin: 0 !important;
    font-family: Calibri, sans-serif;

    textarea {
      font-family: inherit !important;
    }
  }

  .MuiInputBase-root {
    display: unset !important;
    font-size: 14px;
    font-family: inherit !important;
    padding: 11px 10px;
    background-color: transparent !important;
    border-radius: 10px;

    fieldset {
      top: 0;

      legend {
        display: none !important;
      }
    }
  }

  .MuiInputBase-inputMultiline {
    padding: 10px;
    white-space: pre-wrap;
    word-break: break-word;
    box-sizing: border-box;
    resize: none !important;
    overflow: hidden !important;
  }
  .gridInteractionField {
    width: 100% !important;
    border-radius: 10px;
    font-family: Calibri, sans-serif;

    &:hover {
      background-color: transparent !important;
    }
  }
  .MuiDataGrid-row {
    width: calc(100% - var(--DataGrid-scrollbarSize) - 14px);
  }

  @-moz-document url-prefix() {
    .MuiDataGrid-row {
      width: calc(
        100% - var(--DataGrid-scrollbarSize) - var(--DataGrid-scrollbarSize) -
          20px
      );
    }

    .gridInteractionField {
      width: 100% !important;
      border-radius: 10px;

      &:hover {
        background-color: #ffffff !important;
      }
    }

    .MuiDataGrid-scrollbar--vertical {
      margin-top: 1px;
    }
  }
}
#copy-rules-modal-table {
  .fifth-column-header {
    display: flex;
    align-items: center;
    justify-content: center;

    .column-header-title {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      white-space: normal;
      line-height: 1.2;
    }
  }
}
.custom-copy-rule-datepicker {
  .react-datepicker {
    font-size: 12px !important;
  }

  input {
    width: 78%;
    border-radius: 10px 0px 0px 10px;
    padding: 11px 20px 11px 10px;
    background-color: #fff;
    font-family: Calibri, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    box-sizing: border-box;
    height: 42px;
    pointer-events: auto;
    border: 0.5px solid #ccc;
    transition:
      border-color 0.2s ease-in-out,
      box-shadow 0.2s ease-in-out;
  }

  input:focus {
    border: 2px solid #00aeef !important;
    outline: none;
  }

  .calendar-icon {
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
    height: 42px;
    width: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    border-radius: 0px 10px 10px 0px;
  }
  .react-datepicker-popper {
    left: 0px !important;
  }
}
#copy-rules-modal-table {
  .MuiDataGrid-cell.fourth-column-header {
    overflow: visible !important;
  }
}
#copy-rules-modal-table {
  .react-datepicker__triangle {
    left: 100% !important;
    color: #fff !important;
  }
}
#copy-rules-modal-table .ellipsis-cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#copy-rules-modal-table .wrapped-cell {
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.copy-rules-footer {
  height: 65px !important;
}
.react-datepicker-popper[data-placement^='right'] .react-datepicker__triangle {
  left: -10px !important;
  top: 10px !important;
  transform: rotate(-90deg);
}
/* end copy rule modal */

/* Begin Batch Edit Modal */
.batch-edit-modal-container .ModalContentWrapper,
.batch-edit-modal-container .css-olcxlb-ModalContentWrapper {
  width: 100% !important;
  max-width: 886px !important;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 5px;
}
.batch-edit-modal-container
  .MuiOutlinedInput-root:hover:not(.Mui-focused)
  .MuiOutlinedInput-notchedOutline {
  border-color: #ccc !important;
}

.modal-text-defaults {
  font-family: Calibri, sans-serif;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.3;
  color: black;
}
.modal-text-defaults > :not(.react-datepicker),
.modal-text-defaults h6,
.modal-text-defaults svg,
.modal-text-defaults p,
.modal-text-defaults label,
.modal-text-defaults textarea,
.modal-text-defaults select {
  font-family: inherit !important;
  font-size: inherit !important;
  font-weight: inherit !important;
  color: inherit !important;
}

#batch-edit-modal-table {
  max-width: 900px !important;
  width: 100% !important;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 0px 5px;
  box-sizing: border-box;
  font-family: Calibri, sans-serif;
  font-size: 14px;
}

#batch-edit-modal-table .MuiFormControl-root {
  width: 100%;
}

#batch-edit-modal-table .MuiInputBase-root {
  font-family: Calibri, sans-serif;
  font-size: 14px;
  background-color: #ffffff;
  border-radius: 4px;
  height: 32px;
}

#batch-edit-modal-table .MuiSelect-select {
  padding-right: 32px !important;
}

#batch-edit-modal-table .MuiOutlinedInput-notchedOutline {
  border: 1px solid #ccc;
}

#batch-edit-modal-table li.MuiMenuItem-root:hover {
  background-color: #f7fcff !important;
}

#batch-edit-modal-table .MuiTypography-subtitle2,
#batch-edit-modal-table .MuiTypography-subtitle1 {
  font-size: 14px;
  line-height: 1.3;
  color: black;
}
.batch-edit-select {
  font-family: Calibri, sans-serif;
  font-size: 14px !important;
  font-weight: normal;
  line-height: 1.3;
  background-color: #fff;
  border-radius: 4px !important;
  height: 32px;
}

.batch-edit-select .MuiSelect-select {
  display: flex !important;
  align-items: center !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  font-family: Calibri, sans-serif !important;
  font-size: 14px !important;
  color: black !important;
  padding-left: 14px !important;
}

.batch-edit-select .MuiOutlinedInput-notchedOutline {
  border: 1px solid #ccc;
}
.batch-edit-select .MuiSvgIcon-root {
  top: calc(50% - 0.5em) !important;
}
.batch-edit-coming-due-inputs .MuiFormControl-root {
  margin: 0 !important;
}
.batch-edit-overdue-inputs .MuiFormControl-root {
  margin: 0 !important;
}

.batch-edit-coming-due-inputs input,
.batch-edit-overdue-inputs input {
  height: 32px !important;
  padding: 0px 10px !important;
  line-height: 32px !important;
  display: flex;
  align-items: center;
}

.batch-edit-coming-due-inputs input:disabled,
.batch-edit-overdue-inputs input:disabled {
  background-color: #f5f5f5 !important;
  color: black !important;
  -webkit-text-fill-color: black !important;
}
.editbatch-tooltip-button {
  border: none;
  background: transparent;
  padding: 0;
  margin-left: 0px;
  height: 18px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 2px;
}
.editbatch-tooltip {
  font-size: 12px !important;
  color: white !important;
  padding: 6px 8px !important;
  border-radius: 4px !important;
  max-width: 250px !important;
  margin-left: 10px !important;
  font-family: Calibri, sans-serif !important;
}
.add-edit-rule-tooltip {
  font-size: 12px !important;
  color: white !important;
  font-family: Calibri, sans-serif !important;
}
.editbatch-tooltip-icon {
  height: 14px;
  width: 14px;
  fill: #9e9e9e;
  cursor: pointer;
  vertical-align: middle;
  margin-top: -2px;
}
.batch-edit-modal-container .editbatch-error {
  margin-top: 0px !important;
  margin-bottom: 2px !important;
  margin-left: 4px;
  font-size: 11px !important;
  color: red !important;
  font-family: Calibri, sans-serif;
}

.editbatch-checkbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.editbatch-checkbox-wrapper .MuiCheckbox-root {
  padding: 0;
  margin: 0;
  transform: scale(1.3);
}

.step1-date-picker {
  height: 32px;
}

.custom-batch-edit-datepicker {
  input {
    width: 288px;
    border-radius: 4px 0px 0px 4px;
    padding: 11px 20px 11px 10px;
    background-color: #fff;
    font-family: Calibri, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    box-sizing: border-box;
    height: 32px;
    pointer-events: auto;
    border: 1px solid #ccc;
    transition:
      border-color 0.2s ease-in-out,
      box-shadow 0.2s ease-in-out;
  }

  &.step1-date-picker {
    input:disabled {
      background-color: white !important;
      cursor: not-allowed;
    }
    .step1-date-picker.disable-date {
      background-color: white !important;
      cursor: not-allowed;
    }
  }

  input:focus {
    border: 2px solid #00aeef !important;
    outline: none;
  }
  input:disabled {
    background-color: #f5f5f5 !important;
    cursor: not-allowed;
    color: #9e9e9e;
    border: 1px solid #ccc !important;
    box-shadow: none !important;
  }
  input:disabled:focus {
    outline: none !important;
    border: 1px solid #ccc !important;
    box-shadow: none !important;
  }
  .calendar-icon {
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
    height: 32px;
    width: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    border-radius: 0px 4px 4px 0px;
    border: none !important;
  }

  .react-datepicker-popper {
    transform: translate(0px, 42px) !important;
  }
  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle {
    color: white !important;
  }
}

.admin-datagrid,
.step3-table-datepicker {
  .react-datepicker-popper {
    background-color: yellow;
    position: absolute !important;
    > div {
      display: contents !important;
      .react-datepicker {
        display: inline-block !important;
        position: relative !important;
      }
    }
  }
}

/* FireFox overrides */
@-moz-document url-prefix() {
  .custom-batch-edit-datepicker .calendar-icon {
    top: 49% !important; /* was 50% */
    transform: translateY(-50%) !important;
  }
}
/* End Batch Edit Modal */

#add-rule-step3-table {
  .MuiDataGrid-root {
    margin-bottom: 5px;
  }
  .MuiDataGrid-cell {
    overflow: visible;
  }
  .gridInteractionField {
    overflow: visible;
  }
  .MuiDataGrid-virtualScrollerContent,
  .MuiDataGrid-virtualScrollerContent {
    min-height: 450px;
  }
  .MuiDataGrid-cell:not(.PrivateSwitchBase-input, .MuiDataGrid-cellCheckbox) {
    padding-right: 5px !important;
  }
  .react-datepicker-wrapper {
    width: 100%;
  }
  .react-datepicker__input-container {
    width: 100%;
  }
  .custom-datepicker {
    width: 100%;
  }
  .react-datepicker-popper {
    position: absolute !important;
  }
  .custom-datepicker {
    border: 1px solid #000000 !important;
    border-radius: 3px;
    &:disabled:not(.rule-closed) {
      background-color: #f5f5f5;
      color: #9e9e9e;
    }
    &.rule-closed {
      border: 1px solid #cfcfcf !important;
    }
  }
  .calendar-icon {
    border-left: 0 !important;
    border-radius: 0 3px 3px 0;
    border: 1px solid #000000;
  }
  .date-picker-error-message {
    color: red;
    font-size: 11px;
    margin-top: 3px;
    margin-bottom: -3px;
    width: 100%;
  }

  .react-datepicker-popper[data-placement^='top-end']
    .react-datepicker__triangle {
    left: 270px !important;
    color: white !important;
  }

  .react-datepicker-popper[data-placement^='bottom-end']
    .react-datepicker__triangle {
    left: 270px !important;
    color: white !important;
  }

  .MuiDataGrid-columnHeader[data-field^='required'] {
    padding-right: 0 !important;
  }

  .MuiIconButton-sizeSmall {
    padding-left: 0;
    padding-right: 0;
  }
  .MuiDataGrid-columnHeaderTitleContainerContent {
    overflow: visible;
  }

  .MuiSvgIcon-fontSizeMedium {
    width: 20px;
  }

  .custom-datepicker::placeholder {
    color: #cfcfcf;
  }

  @media screen and (max-width: 1500px) {
    .date-picker-error-message {
      font-size: 12px;
    }
    .MuiDataGrid-root,
    .date-picker-error-message {
      transform: scale(0.9);
      transform-origin: top center;
      width: 111%;
      margin-left: -5.5%;
    }
  }
  @media screen and (max-width: 1400px) {
    .MuiDataGrid-root,
    .date-picker-error-message {
      transform: scale(0.8333);
      transform-origin: top center;
      width: 120%;
      margin-left: -10%;
    }
  }

  @media screen and (max-width: 1250px) {
    .MuiDataGrid-root {
      transform: scale(0.8);
      width: 125%;
      margin-left: -12.5%;
    }
  }

  @media screen and (max-width: 1175px) {
    .MuiDataGrid-root {
      transform: scale(0.75);
      width: 133.33%;
      margin-left: -16.67%;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/features/admin.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C,0BAA0B;;AAE1B;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;;EAEnB;IACE;MACE;QACE,iBAAiB;QACjB,qBAAqB;QACrB,gCAAgC;QAChC,YAAY;QACZ,8BAA8B;MAChC;IACF;EACF;AACF;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;;EAEf;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+CAA+C;EAC/C;IACE,mBAAmB;IACnB,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,wBAAwB;EAC1B;;EAEA,uEAAuE;EACvE;;IAEE,sBAAsB;EACxB;AACF;AACA,6BAA6B;;AAE7B,yBAAyB;AACzB;EACE,WAAW;EACX,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA,4BAA4B;;AAE5B,sBAAsB;;AAEtB;;EAEE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;IACtC,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;;IAEb;MACE,WAAW;IACb;;IAEA;MACE,iBAAiB;IACnB;IACA;MACE,eAAe;MACf,aAAa;MACb,mBAAmB;;MAEnB;QACE,YAAY;QACZ,WAAW;MACb;IACF;;IAEA;MACE,wBAAwB;MACxB;QACE,wBAAwB;QACxB,uBAAuB;QACvB,eAAe;QACf,WAAW;MACb;IACF;;IAEA;MACE,wBAAwB;MACxB;QACE,WAAW;MACb;IACF;;IAEA;MACE,wBAAwB;;MAExB;QACE,eAAe;QACf,WAAW;QACX,eAAe;QACf,qBAAqB;QACrB,qBAAqB;QACrB,kBAAkB;MACpB;IACF;;IAEA;MACE,wBAAwB;;MAExB;QACE,YAAY;QACZ,WAAW;MACb;IACF;EACF;;EAEA;IACE,oBAAoB;;IAEpB;MACE,8BAA8B;MAC9B,mBAAmB;MACnB,6CAA6C;MAC7C,2BAA2B;MAC3B,4BAA4B;MAC5B,2DAA2D;MAC3D;+DACyD;MACzD;oEAC8D;MAC9D;6EACuE;MACvE,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE;QACE,iCAAiC;;QAEjC;UACE,0BAA0B;UAC1B,iCAAiC;UACjC;YACE,mBAAmB;UACrB;QACF;MACF;IACF;EACF;AACF;AACA,mBAAmB;;AAEnB,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;;EAEZ;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;;IAEhB;MACE,gBAAgB;MAChB,uBAAuB;MACvB,mBAAmB;MACnB,eAAe;IACjB;EACF;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,4BAA4B;AAC9B;AACA,6BAA6B;;AAE7B,6BAA6B;AAC7B;EACE;IACE;MACE,yBAAyB;IAC3B;IACA;MACE,wBAAwB;IAC1B;IACA;MACE;QACE,gBAAgB;QAChB,yBAAyB;QACzB,qDAAqD;MACvD;;MAEA;QACE,gBAAgB;MAClB;IACF;;IAEA;MACE,2BAA2B;MAC3B,2BAA2B;;MAE3B;QACE,4BAA4B;QAC5B;UACE,UAAU;UACV,iBAAiB;QACnB;MACF;IACF;;IAEA;MACE,gFAAgF;;MAEhF;QACE;UACE,iBAAiB;UACjB,mBAAmB;QACrB;QACA;UACE,kBAAkB;QACpB;MACF;IACF;IACA;MACE,+DAA+D;MAC/D,8DAA8D;IAChE;;IAEA;MACE,eAAe;;MAEf;QACE,uBAAuB;QACvB,qDAAqD;;QAErD;UACE,cAAc;UACd,gBAAgB;QAClB;QACA;UACE,gBAAgB;QAClB;MACF;IACF;;IAEA;;MAEE,aAAa;MACb,gBAAgB;IAClB;;IAEA;MACE,sBAAsB;MACtB,wBAAwB;;MAExB;QACE,oCAAoC;MACtC;IACF;;IAEA;MACE,sBAAsB;MACtB,gCAAgC;MAChC;QACE,+BAA+B;MACjC;IACF;;IAEA;MACE,yBAAyB;MACzB,eAAe;MACf,+BAA+B;MAC/B,kBAAkB;;MAElB;QACE,MAAM;QACN;UACE,wBAAwB;QAC1B;MACF;IACF;;IAEA,sBAAsB;IACtB;MACE;QACE;;;SAGC;MACH;;MAEA;QACE,qBAAqB;MACvB;MACA;QACE,eAAe;MACjB;IACF;;IAEA;MACE,uBAAuB;MACvB,2BAA2B;IAC7B;EACF;AACF;;AAEA,2BAA2B;;AAE3B,uDAAuD;AACvD;;;;;;;EAOE;IACE,gCAAgC;IAChC;;MAEE,oCAAoC;IACtC;EACF;EACA;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;;IAEE;;MAEE,oCAAoC;IACtC;EACF;AACF;AACA,qDAAqD;;AAErD,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,eAAe;;EAEf;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE;MACE,gBAAgB;MAChB,yBAAyB;MACzB,qDAAqD;IACvD;EACF;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oCAAoC;IACpC,2BAA2B;IAC3B,4BAA4B;;IAE5B;MACE,4BAA4B;MAC5B,eAAe;;MAEf;QACE,UAAU;QACV,iBAAiB;MACnB;IACF;EACF;;EAEA;IACE,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;IACE,gFAAgF;;IAEhF;MACE;QACE,kBAAkB;MACpB;;MAEA;QACE,kBAAkB;QAClB,mBAAmB;MACrB;;MAEA;;QAEE,kBAAkB;QAClB,mBAAmB;MACrB;;MAEA;QACE,kBAAkB;MACpB;IACF;;IAEA;MACE,4DAA4D;IAC9D;EACF;;EAEA;IACE,+DAA+D;IAC/D,8DAA8D;EAChE;EACA;;IAEE,aAAa;IACb,gBAAgB;IAChB,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,4BAA4B;;IAE5B;MACE,uBAAuB;MACvB,qDAAqD;;MAErD;QACE,cAAc;QACd,gBAAgB;MAClB;MACA;QACE,gBAAgB;MAClB;IACF;EACF;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,gCAAgC;;IAEhC;MACE,+BAA+B;IACjC;EACF;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;;IAEnB;MACE,MAAM;;MAEN;QACE,wBAAwB;MAC1B;IACF;EACF;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;EAC7B;EACA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gCAAgC;;IAEhC;MACE,wCAAwC;IAC1C;EACF;EACA;IACE,wDAAwD;EAC1D;;EAEA;IACE;MACE;;;OAGC;IACH;;IAEA;MACE,sBAAsB;MACtB,mBAAmB;;MAEnB;QACE,oCAAoC;MACtC;IACF;;IAEA;MACE,eAAe;IACjB;EACF;AACF;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB;MAClB,mBAAmB;MACnB,gBAAgB;IAClB;EACF;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,4BAA4B;IAC5B,sBAAsB;IACtB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;IACZ,oBAAoB;IACpB,wBAAwB;IACxB;;iCAE6B;EAC/B;;EAEA;IACE,oCAAoC;IACpC,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,gCAAgC;EAClC;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA,wBAAwB;;AAExB,2BAA2B;AAC3B;;EAEE,sBAAsB;EACtB,2BAA2B;EAC3B,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;AACA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;AACA;;;;;;;EAOE,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,2CAA2C;EAC3C,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,oCAAoC;EACpC,uBAAuB;EACvB,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,2CAA2C;AAC7C;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,2CAA2C;AAC7C;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;IACZ,8BAA8B;IAC9B,4BAA4B;IAC5B,sBAAsB;IACtB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;IACZ,oBAAoB;IACpB,sBAAsB;IACtB;;iCAE6B;EAC/B;;EAEA;IACE;MACE,kCAAkC;MAClC,mBAAmB;IACrB;IACA;MACE,kCAAkC;MAClC,mBAAmB;IACrB;EACF;;EAEA;IACE,oCAAoC;IACpC,aAAa;EACf;EACA;IACE,oCAAoC;IACpC,mBAAmB;IACnB,cAAc;IACd,iCAAiC;IACjC,2BAA2B;EAC7B;EACA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;EAC7B;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA;IACE,0CAA0C;EAC5C;EACA;;IAEE,uBAAuB;EACzB;AACF;;AAEA;;EAEE;IACE,wBAAwB;IACxB,6BAA6B;IAC7B;MACE,4BAA4B;MAC5B;QACE,gCAAgC;QAChC,6BAA6B;MAC/B;IACF;EACF;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB,EAAE,YAAY;IACjC,sCAAsC;EACxC;AACF;AACA,yBAAyB;;AAEzB;EACE;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oCAAoC;IACpC,kBAAkB;IAClB;MACE,yBAAyB;MACzB,cAAc;IAChB;IACA;MACE,oCAAoC;IACtC;EACF;EACA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;IACE,UAAU;IACV,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;;EAEA;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE;MACE,eAAe;IACjB;IACA;;MAEE,qBAAqB;MACrB,4BAA4B;MAC5B,WAAW;MACX,kBAAkB;IACpB;EACF;EACA;IACE;;MAEE,wBAAwB;MACxB,4BAA4B;MAC5B,WAAW;MACX,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,qBAAqB;MACrB,WAAW;MACX,mBAAmB;IACrB;EACF;;EAEA;IACE;MACE,sBAAsB;MACtB,cAAc;MACd,oBAAoB;IACtB;EACF;AACF","sourcesContent":["/* Global styling for adminstrator pages */\n\n/*#region Recommendations*/\n\n#admin-recommendations {\n  width: 100vw;\n  margin-top: 13px;\n}\n\n.search-filter-bar {\n  height: 40px;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.dropdown-filter {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-left: 20px;\n  font-size: 15px;\n  font-family: Calibri;\n}\n\n.skill-dropdown {\n  width: 173px;\n  display: flex;\n  align-items: center;\n\n  > .MuiFormControl-root {\n    > .MuiOutlinedInput-root {\n      > .MuiSelect-select {\n        padding-left: 6px;\n        align-content: center;\n        border-color: #6e6e6e !important;\n        height: 36px;\n        border-radius: 10px !important;\n      }\n    }\n  }\n}\n\n.skill-role-table {\n  width: 100vw;\n  box-sizing: border-box;\n}\n\n.column-header-title {\n  font-weight: 800;\n  font-size: 15px;\n\n  &.left-col {\n    margin-left: 10px;\n  }\n\n  &.first {\n    margin-left: 20px;\n  }\n}\n\n.first-column-header {\n  .MuiDataGrid-iconButtonContainer {\n    visibility: 'visible';\n  }\n\n  .MuiDataGrid-sortIcon {\n    opacity: 'inherit !important';\n  }\n}\n\n.MuiTooltip-root {\n  display: none;\n}\n\n.MuiToolbar-root {\n  padding: 0px !important;\n}\n\n.MuiTablePagination-selectLabel {\n  display: none !important;\n}\n\n.MuiDataGrid-root {\n  /* Remove possible gap below DataGrid content */\n  .MuiDataGrid-virtualScrollerContent {\n    line-height: normal;\n    padding-bottom: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .MuiDataGrid-row:last-child {\n    margin-bottom: 0 !important;\n  }\n  > .MuiInputBase-root,\n  .MuiInputBase-colorPrimary:not(.step-3) {\n    display: none !important;\n  }\n\n  /* Ensure consistent box model for DataGrid virtual scroller and rows */\n  .MuiDataGrid-virtualScrollerContent,\n  .MuiDataGrid-row {\n    box-sizing: border-box;\n  }\n}\n/*#endregion Recommendations*/\n\n/*#region Overdue Banner*/\n#overdue-banner-react {\n  width: 100%;\n  background-color: whitesmoke;\n  border-bottom: 1px solid black;\n  font-family: Calibri, sans-serif;\n}\n\n#overdue-banner-react .warning-icon {\n  color: white;\n  padding-left: 6px;\n}\n\n#overdue-banner-react p {\n  font-weight: bold;\n  padding-left: 20px;\n  font-size: 15px;\n  line-height: 17.15px;\n  padding-bottom: 5px;\n}\n\n#overdue-banner-react span {\n  font-weight: 400;\n}\n\n#overdue-banner-react table {\n  margin-left: 40px;\n  margin-bottom: 20px;\n  font-size: 15px;\n  line-height: 17.15px;\n}\n\n#overdue-banner-react table #header {\n  border-bottom: 1px solid black;\n}\n\n#overdue-banner-react table th,\n#overdue-banner-react table td {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n#overdue-banner-react table .padding-right {\n  padding-right: 80px;\n}\n\n#overdue-banner-react h3 {\n  border-bottom: 1px solid black;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  margin-top: 0px;\n  text-align: center;\n  background-color: rgb(231, 68, 68);\n  color: white;\n  font-size: 28px;\n}\n\n#overdue-banner-react #error {\n  margin-left: 20px;\n  margin-right: 20px;\n}\n\n#overdue-banner-react #overdue-total {\n  border-top-style: solid;\n  border-top-width: 1px;\n  font-weight: bold;\n}\n\n#overdue-banner-react .invoice-pdf-button {\n  border: none;\n  text-decoration: underline;\n  background: none;\n  font-size: 14px;\n  color: #505050;\n  padding: 0px;\n}\n\n/*#endregion Overdue Banner*/\n\n/* #custom data grid */\n\n#admin-content-table .third-column-header.MuiDataGrid-columnHeader,\n#admin-content-table .third-column-header.MuiDataGrid-cell {\n  padding-left: 8px !important;\n  padding-right: 8px !important;\n}\n\n.admin-datagrid {\n  .MuiDataGrid-cell:last-of-type {\n    display: flex;\n    flex-wrap: wrap;\n    align-content: baseline !important;\n    margin: 0.2rem 0 !important;\n  }\n\n  .MuiDataGrid-columnHeaderTitleContainerContent {\n    margin-left: inherit;\n  }\n\n  .column-header-title {\n    &.first {\n      margin-left: 0px;\n    }\n\n    &.left-col {\n      margin-left: 0px;\n    }\n  }\n\n  .MuiTouchRipple-root {\n    background-color: transparent;\n  }\n\n  .MuiDataGrid-columnHeaderTitleContainerContent .MuiCheckbox-root {\n    padding-top: 0;\n    background-color: inherit;\n  }\n\n  .action-buttons {\n    margin: 0.2rem 5px 0.2rem 0 !important;\n    min-width: 15px !important;\n    width: 25px;\n    height: 23px;\n    padding: 0px;\n    display: flex;\n\n    &:first-child {\n      width: 47px;\n    }\n\n    &:last-child {\n      margin-right: 0px;\n    }\n    .MuiListItemIcon-root {\n      height: inherit;\n      display: flex;\n      align-items: center;\n\n      > svg {\n        height: 125%;\n        width: 100%;\n      }\n    }\n\n    &.pencil {\n      padding: 0px 0px 1px 2px;\n      > svg {\n        fill: rgb(255, 255, 255);\n        stroke: rgb(46, 46, 46);\n        height: 28.75px;\n        width: 36px;\n      }\n    }\n\n    &.eye {\n      padding: 1px 0px 0px 0px;\n      svg {\n        height: 95%;\n      }\n    }\n\n    &.reprocess {\n      padding: 1px 0px 0px 0px;\n\n      svg {\n        height: 21.84px;\n        width: 36px;\n        stroke: #2e2e2e;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 15px;\n      }\n    }\n\n    &.deactivate {\n      padding: 1px 0px 0px 0px;\n\n      svg {\n        height: 18px;\n        width: 36px;\n      }\n    }\n  }\n\n  input[type='checkbox'] {\n    margin: 0 !important;\n\n    &.focus {\n      outline: 2px solid transparent;\n      outline-offset: 2px;\n      --tw-ring-inset: var(--tw-empty, /*!*/ /*!*/);\n      --tw-ring-offset-width: 0px;\n      --tw-ring-offset-color: #fff;\n      --tw-ring-color: theme('colors.blue.600', colors.blue[600]);\n      --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0\n        var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n      --tw-ring-shadow: `var(--tw-ring-inset) 0 0 0\n        calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);\n      box-shadow:\n        var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);\n      border-color: none;\n    }\n  }\n\n  .MuiDataGrid-row {\n    &.top-aligned-row {\n      .MuiDataGrid-cell {\n        align-self: flex-start !important;\n\n        .MuiCheckbox-root {\n          margin-top: 4px !important;\n          align-self: flex-start !important;\n          input[type='checkbox'] {\n            top: 0px !important;\n          }\n        }\n      }\n    }\n  }\n}\n/* #end data grid */\n\n/* # begin admin content table */\n#admin-content-table {\n  width: 100%;\n  min-width: 0;\n\n  > div {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .MuiDataGrid-root {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .MuiDataGrid-cell {\n    overflow: hidden;\n\n    > * {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      max-width: 100%;\n    }\n  }\n\n  .MuiDataGrid-columnHeader {\n    overflow: hidden;\n  }\n}\n\n#admin-content-table .action-buttons:last-child {\n  margin-right: 0px !important;\n}\n/* #end admin content table */\n\n/* begin people group modal */\n#root:has(.admin-datagrid) ~ div[role='presentation'] {\n  #copy-people-group-modal-table {\n    .MuiDataGrid-scrollbarFiller--header {\n      background-color: #f7fcff;\n    }\n    .MuiDataGrid-filler {\n      height: 30px !important ;\n    }\n    .MuiDataGrid-container--top {\n      .MuiDataGrid-filler {\n        margin-top: -2px;\n        background-color: #f7fcff;\n        height: var(--DataGrid-topContainerHeight) !important;\n      }\n\n      .MuiDataGrid-scrollbarFiller--header {\n        margin-top: -2px;\n      }\n    }\n\n    .MuiDataGrid-columnHeader {\n      border-top: none !important;\n      margin-top: -2px !important;\n\n      .column-header-title {\n        margin-left: 12px !important;\n        .required {\n          color: red;\n          padding-left: 2px;\n        }\n      }\n    }\n\n    .MuiDataGrid-virtualScrollerContent {\n      /* Removed explicit height to fix 2px gap issue. Let content determine height. */\n\n      div[role='row'] {\n        > div[role='gridcell']:nth-of-type(2) {\n          margin-left: 12px;\n          padding-right: 10px;\n        }\n        div[role='gridcell']:nth-last-of-type(1) {\n          margin-right: 12px;\n        }\n      }\n    }\n    .MuiDataGrid-virtualScroller {\n      /* uses the height of the modal - header height - 4px padding */\n      min-height: calc((450px - var(--DataGrid-headerHeight)) - 4px);\n    }\n\n    .MuiDataGrid-main {\n      height: inherit;\n\n      + .MuiBox-root {\n        padding: 4px !important;\n        height: var(--DataGrid-topContainerHeight) !important;\n\n        .MuiTablePagination-root {\n          padding: 2px 0;\n          margin-top: -4px;\n        }\n        .MuiTablePagination-actions {\n          margin-left: 9px;\n        }\n      }\n    }\n\n    .MuiDataGrid-cell--editing,\n    .MuiDataGrid-cell--editable {\n      outline: none;\n      box-shadow: none;\n    }\n\n    .gridInteractionField {\n      width: 100% !important;\n      border-radius: 10px 10px;\n\n      &:hover {\n        background-color: #ffffff !important;\n      }\n    }\n\n    .MuiFormControl-root {\n      margin: 0 0 !important;\n      font-family: Calibri, sans-serif;\n      textarea {\n        font-family: inherit !important;\n      }\n    }\n\n    .MuiInputBase-root {\n      display: unset !important;\n      font-size: 14px;\n      font-family: inherit !important;\n      padding: 11px 10px;\n\n      & fieldset {\n        top: 0;\n        & legend {\n          display: none !important;\n        }\n      }\n    }\n\n    /* FireFox overrides */\n    @-moz-document url-prefix() {\n      .MuiDataGrid-row {\n        width: calc(\n          100% - var(--DataGrid-scrollbarSize) - var(--DataGrid-scrollbarSize) -\n            20px\n        );\n      }\n\n      .gridInteractionField {\n        width: 98% !important;\n      }\n      .MuiDataGrid-scrollbar--vertical {\n        margin-top: 1px;\n      }\n    }\n\n    .MuiDataGrid-main + .MuiBox-root {\n      height: auto !important;\n      min-height: 65px !important;\n    }\n  }\n}\n\n/* end people group modal */\n\n/* #begin common for tabs admin recs and admin rules  */\n#root:has(\n    #admin-rules-main-container,\n    #admin-recommendations,\n    .input-wrapper #people-group-audience-modal-table,\n    #rule-preview-modal-table\n  )\n  ~ div[role='presentation'] {\n  li.MuiMenuItem-root[role='option'] {\n    font-family: Calibri, sans-serif;\n    &:focus,\n    &:hover {\n      background-color: #f7fcff !important;\n    }\n  }\n  .MuiAutocomplete-option[aria-selected='true'] {\n    background-color: #f7fcff !important;\n  }\n\n  .MuiDataGrid-columnHeader {\n    background-color: #f7fcff !important;\n  }\n\n  #people-group-audience-modal-table,\n  #rule-preview-modal-table {\n    tr th.MuiTableCell-root,\n    .MuiTableRow-root:hover {\n      background-color: #f7fcff !important;\n    }\n  }\n}\n/* #end common for tabs admin recs and admin rules  */\n\n/* begin copy rule modal */\n#copy-rules-modal-table {\n  position: relative;\n  overflow: unset;\n\n  .MuiDataGrid-scrollbarFiller--header {\n    background-color: #f7fcff;\n    margin-top: -2px;\n  }\n\n  .MuiDataGrid-filler {\n    height: 30px !important;\n  }\n\n  .MuiDataGrid-container--top {\n    .MuiDataGrid-filler {\n      margin-top: -2px;\n      background-color: #f7fcff;\n      height: var(--DataGrid-topContainerHeight) !important;\n    }\n  }\n  .MuiDataGrid-cell {\n    align-self: center !important;\n  }\n  .MuiDataGrid-columnHeader {\n    background-color: #f7fcff !important;\n    border-top: none !important;\n    font-weight: bold !important;\n\n    .column-header-title {\n      margin-left: 12px !important;\n      font-size: 15px;\n\n      .required {\n        color: red;\n        padding-left: 2px;\n      }\n    }\n  }\n\n  .MuiDataGrid-columnHeaderTitleContainerContent {\n    white-space: normal !important;\n    overflow: visible !important;\n  }\n\n  .MuiDataGrid-virtualScrollerContent {\n    /* Removed explicit height to fix 2px gap issue. Let content determine height. */\n\n    div[role='row'] {\n      > div[role='gridcell']:nth-of-type(1) {\n        padding-left: 12px;\n      }\n\n      > div[role='gridcell']:nth-of-type(2) {\n        padding-left: 12px;\n        padding-right: 12px;\n      }\n\n      > div[role='gridcell']:nth-of-type(3),\n      > div[role='gridcell']:nth-of-type(4) {\n        padding-left: 12px;\n        padding-right: 12px;\n      }\n\n      > div[role='gridcell']:nth-of-type(5) {\n        padding-left: 12px;\n      }\n    }\n\n    .MuiDataGrid-row {\n      width: calc(100% - var(--DataGrid-scrollbarSize)) !important;\n    }\n  }\n\n  .MuiDataGrid-virtualScroller {\n    /* uses the height of the modal - header height - 4px padding */\n    min-height: calc((448px - var(--DataGrid-headerHeight)) - 0px);\n  }\n  .MuiDataGrid-cell--editing,\n  .MuiDataGrid-cell--editable {\n    outline: none;\n    box-shadow: none;\n    background-color: transparent;\n  }\n  .MuiDataGrid-main {\n    height: inherit;\n    overflow: visible !important;\n\n    + .MuiBox-root {\n      padding: 4px !important;\n      height: var(--DataGrid-topContainerHeight) !important;\n\n      .MuiTablePagination-root {\n        padding: 2px 0;\n        margin-top: -4px;\n      }\n      .MuiTablePagination-actions {\n        margin-left: 9px;\n      }\n    }\n  }\n\n  .MuiInputBase-root textarea {\n    white-space: pre-wrap;\n    word-break: break-word;\n    padding: 0px;\n    font-size: 14px;\n    resize: none;\n    overflow: hidden;\n    height: auto;\n  }\n\n  .MuiFormControl-root {\n    margin: 0 !important;\n    font-family: Calibri, sans-serif;\n\n    textarea {\n      font-family: inherit !important;\n    }\n  }\n\n  .MuiInputBase-root {\n    display: unset !important;\n    font-size: 14px;\n    font-family: inherit !important;\n    padding: 11px 10px;\n    background-color: transparent !important;\n    border-radius: 10px;\n\n    fieldset {\n      top: 0;\n\n      legend {\n        display: none !important;\n      }\n    }\n  }\n\n  .MuiInputBase-inputMultiline {\n    padding: 10px;\n    white-space: pre-wrap;\n    word-break: break-word;\n    box-sizing: border-box;\n    resize: none !important;\n    overflow: hidden !important;\n  }\n  .gridInteractionField {\n    width: 100% !important;\n    border-radius: 10px;\n    font-family: Calibri, sans-serif;\n\n    &:hover {\n      background-color: transparent !important;\n    }\n  }\n  .MuiDataGrid-row {\n    width: calc(100% - var(--DataGrid-scrollbarSize) - 14px);\n  }\n\n  @-moz-document url-prefix() {\n    .MuiDataGrid-row {\n      width: calc(\n        100% - var(--DataGrid-scrollbarSize) - var(--DataGrid-scrollbarSize) -\n          20px\n      );\n    }\n\n    .gridInteractionField {\n      width: 100% !important;\n      border-radius: 10px;\n\n      &:hover {\n        background-color: #ffffff !important;\n      }\n    }\n\n    .MuiDataGrid-scrollbar--vertical {\n      margin-top: 1px;\n    }\n  }\n}\n#copy-rules-modal-table {\n  .fifth-column-header {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .column-header-title {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      text-align: center;\n      white-space: normal;\n      line-height: 1.2;\n    }\n  }\n}\n.custom-copy-rule-datepicker {\n  .react-datepicker {\n    font-size: 12px !important;\n  }\n\n  input {\n    width: 78%;\n    border-radius: 10px 0px 0px 10px;\n    padding: 11px 20px 11px 10px;\n    background-color: #fff;\n    font-family: Calibri, sans-serif;\n    font-size: 14px;\n    line-height: 1.5;\n    box-sizing: border-box;\n    height: 42px;\n    pointer-events: auto;\n    border: 0.5px solid #ccc;\n    transition:\n      border-color 0.2s ease-in-out,\n      box-shadow 0.2s ease-in-out;\n  }\n\n  input:focus {\n    border: 2px solid #00aeef !important;\n    outline: none;\n  }\n\n  .calendar-icon {\n    position: absolute;\n    right: 0px;\n    top: 50%;\n    transform: translateY(-50%);\n    height: 42px;\n    width: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    pointer-events: none;\n    border-radius: 0px 10px 10px 0px;\n  }\n  .react-datepicker-popper {\n    left: 0px !important;\n  }\n}\n#copy-rules-modal-table {\n  .MuiDataGrid-cell.fourth-column-header {\n    overflow: visible !important;\n  }\n}\n#copy-rules-modal-table {\n  .react-datepicker__triangle {\n    left: 100% !important;\n    color: #fff !important;\n  }\n}\n#copy-rules-modal-table .ellipsis-cell {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#copy-rules-modal-table .wrapped-cell {\n  white-space: pre-wrap;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n}\n.copy-rules-footer {\n  height: 65px !important;\n}\n.react-datepicker-popper[data-placement^='right'] .react-datepicker__triangle {\n  left: -10px !important;\n  top: 10px !important;\n  transform: rotate(-90deg);\n}\n/* end copy rule modal */\n\n/* Begin Batch Edit Modal */\n.batch-edit-modal-container .ModalContentWrapper,\n.batch-edit-modal-container .css-olcxlb-ModalContentWrapper {\n  width: 100% !important;\n  max-width: 886px !important;\n  margin: 0 auto;\n  box-sizing: border-box;\n  padding: 0 5px;\n}\n.batch-edit-modal-container\n  .MuiOutlinedInput-root:hover:not(.Mui-focused)\n  .MuiOutlinedInput-notchedOutline {\n  border-color: #ccc !important;\n}\n\n.modal-text-defaults {\n  font-family: Calibri, sans-serif;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.3;\n  color: black;\n}\n.modal-text-defaults > :not(.react-datepicker),\n.modal-text-defaults h6,\n.modal-text-defaults svg,\n.modal-text-defaults p,\n.modal-text-defaults label,\n.modal-text-defaults textarea,\n.modal-text-defaults select {\n  font-family: inherit !important;\n  font-size: inherit !important;\n  font-weight: inherit !important;\n  color: inherit !important;\n}\n\n#batch-edit-modal-table {\n  max-width: 900px !important;\n  width: 100% !important;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  padding: 0px 5px;\n  box-sizing: border-box;\n  font-family: Calibri, sans-serif;\n  font-size: 14px;\n}\n\n#batch-edit-modal-table .MuiFormControl-root {\n  width: 100%;\n}\n\n#batch-edit-modal-table .MuiInputBase-root {\n  font-family: Calibri, sans-serif;\n  font-size: 14px;\n  background-color: #ffffff;\n  border-radius: 4px;\n  height: 32px;\n}\n\n#batch-edit-modal-table .MuiSelect-select {\n  padding-right: 32px !important;\n}\n\n#batch-edit-modal-table .MuiOutlinedInput-notchedOutline {\n  border: 1px solid #ccc;\n}\n\n#batch-edit-modal-table li.MuiMenuItem-root:hover {\n  background-color: #f7fcff !important;\n}\n\n#batch-edit-modal-table .MuiTypography-subtitle2,\n#batch-edit-modal-table .MuiTypography-subtitle1 {\n  font-size: 14px;\n  line-height: 1.3;\n  color: black;\n}\n.batch-edit-select {\n  font-family: Calibri, sans-serif;\n  font-size: 14px !important;\n  font-weight: normal;\n  line-height: 1.3;\n  background-color: #fff;\n  border-radius: 4px !important;\n  height: 32px;\n}\n\n.batch-edit-select .MuiSelect-select {\n  display: flex !important;\n  align-items: center !important;\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n  font-family: Calibri, sans-serif !important;\n  font-size: 14px !important;\n  color: black !important;\n  padding-left: 14px !important;\n}\n\n.batch-edit-select .MuiOutlinedInput-notchedOutline {\n  border: 1px solid #ccc;\n}\n.batch-edit-select .MuiSvgIcon-root {\n  top: calc(50% - 0.5em) !important;\n}\n.batch-edit-coming-due-inputs .MuiFormControl-root {\n  margin: 0 !important;\n}\n.batch-edit-overdue-inputs .MuiFormControl-root {\n  margin: 0 !important;\n}\n\n.batch-edit-coming-due-inputs input,\n.batch-edit-overdue-inputs input {\n  height: 32px !important;\n  padding: 0px 10px !important;\n  line-height: 32px !important;\n  display: flex;\n  align-items: center;\n}\n\n.batch-edit-coming-due-inputs input:disabled,\n.batch-edit-overdue-inputs input:disabled {\n  background-color: #f5f5f5 !important;\n  color: black !important;\n  -webkit-text-fill-color: black !important;\n}\n.editbatch-tooltip-button {\n  border: none;\n  background: transparent;\n  padding: 0;\n  margin-left: 0px;\n  height: 18px;\n  width: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin-top: 2px;\n}\n.editbatch-tooltip {\n  font-size: 12px !important;\n  color: white !important;\n  padding: 6px 8px !important;\n  border-radius: 4px !important;\n  max-width: 250px !important;\n  margin-left: 10px !important;\n  font-family: Calibri, sans-serif !important;\n}\n.add-edit-rule-tooltip {\n  font-size: 12px !important;\n  color: white !important;\n  font-family: Calibri, sans-serif !important;\n}\n.editbatch-tooltip-icon {\n  height: 14px;\n  width: 14px;\n  fill: #9e9e9e;\n  cursor: pointer;\n  vertical-align: middle;\n  margin-top: -2px;\n}\n.batch-edit-modal-container .editbatch-error {\n  margin-top: 0px !important;\n  margin-bottom: 2px !important;\n  margin-left: 4px;\n  font-size: 11px !important;\n  color: red !important;\n  font-family: Calibri, sans-serif;\n}\n\n.editbatch-checkbox-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n\n.editbatch-checkbox-wrapper .MuiCheckbox-root {\n  padding: 0;\n  margin: 0;\n  transform: scale(1.3);\n}\n\n.step1-date-picker {\n  height: 32px;\n}\n\n.custom-batch-edit-datepicker {\n  input {\n    width: 288px;\n    border-radius: 4px 0px 0px 4px;\n    padding: 11px 20px 11px 10px;\n    background-color: #fff;\n    font-family: Calibri, sans-serif;\n    font-size: 14px;\n    line-height: 1.5;\n    box-sizing: border-box;\n    height: 32px;\n    pointer-events: auto;\n    border: 1px solid #ccc;\n    transition:\n      border-color 0.2s ease-in-out,\n      box-shadow 0.2s ease-in-out;\n  }\n\n  &.step1-date-picker {\n    input:disabled {\n      background-color: white !important;\n      cursor: not-allowed;\n    }\n    .step1-date-picker.disable-date {\n      background-color: white !important;\n      cursor: not-allowed;\n    }\n  }\n\n  input:focus {\n    border: 2px solid #00aeef !important;\n    outline: none;\n  }\n  input:disabled {\n    background-color: #f5f5f5 !important;\n    cursor: not-allowed;\n    color: #9e9e9e;\n    border: 1px solid #ccc !important;\n    box-shadow: none !important;\n  }\n  input:disabled:focus {\n    outline: none !important;\n    border: 1px solid #ccc !important;\n    box-shadow: none !important;\n  }\n  .calendar-icon {\n    position: absolute;\n    right: 0px;\n    top: 50%;\n    transform: translateY(-50%);\n    height: 32px;\n    width: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    pointer-events: none;\n    border-radius: 0px 4px 4px 0px;\n    border: none !important;\n  }\n\n  .react-datepicker-popper {\n    transform: translate(0px, 42px) !important;\n  }\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle {\n    color: white !important;\n  }\n}\n\n.admin-datagrid,\n.step3-table-datepicker {\n  .react-datepicker-popper {\n    background-color: yellow;\n    position: absolute !important;\n    > div {\n      display: contents !important;\n      .react-datepicker {\n        display: inline-block !important;\n        position: relative !important;\n      }\n    }\n  }\n}\n\n/* FireFox overrides */\n@-moz-document url-prefix() {\n  .custom-batch-edit-datepicker .calendar-icon {\n    top: 49% !important; /* was 50% */\n    transform: translateY(-50%) !important;\n  }\n}\n/* End Batch Edit Modal */\n\n#add-rule-step3-table {\n  .MuiDataGrid-root {\n    margin-bottom: 5px;\n  }\n  .MuiDataGrid-cell {\n    overflow: visible;\n  }\n  .gridInteractionField {\n    overflow: visible;\n  }\n  .MuiDataGrid-virtualScrollerContent,\n  .MuiDataGrid-virtualScrollerContent {\n    min-height: 450px;\n  }\n  .MuiDataGrid-cell:not(.PrivateSwitchBase-input, .MuiDataGrid-cellCheckbox) {\n    padding-right: 5px !important;\n  }\n  .react-datepicker-wrapper {\n    width: 100%;\n  }\n  .react-datepicker__input-container {\n    width: 100%;\n  }\n  .custom-datepicker {\n    width: 100%;\n  }\n  .react-datepicker-popper {\n    position: absolute !important;\n  }\n  .custom-datepicker {\n    border: 1px solid #000000 !important;\n    border-radius: 3px;\n    &:disabled:not(.rule-closed) {\n      background-color: #f5f5f5;\n      color: #9e9e9e;\n    }\n    &.rule-closed {\n      border: 1px solid #cfcfcf !important;\n    }\n  }\n  .calendar-icon {\n    border-left: 0 !important;\n    border-radius: 0 3px 3px 0;\n    border: 1px solid #000000;\n  }\n  .date-picker-error-message {\n    color: red;\n    font-size: 11px;\n    margin-top: 3px;\n    margin-bottom: -3px;\n    width: 100%;\n  }\n\n  .react-datepicker-popper[data-placement^='top-end']\n    .react-datepicker__triangle {\n    left: 270px !important;\n    color: white !important;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom-end']\n    .react-datepicker__triangle {\n    left: 270px !important;\n    color: white !important;\n  }\n\n  .MuiDataGrid-columnHeader[data-field^='required'] {\n    padding-right: 0 !important;\n  }\n\n  .MuiIconButton-sizeSmall {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .MuiDataGrid-columnHeaderTitleContainerContent {\n    overflow: visible;\n  }\n\n  .MuiSvgIcon-fontSizeMedium {\n    width: 20px;\n  }\n\n  .custom-datepicker::placeholder {\n    color: #cfcfcf;\n  }\n\n  @media screen and (max-width: 1500px) {\n    .date-picker-error-message {\n      font-size: 12px;\n    }\n    .MuiDataGrid-root,\n    .date-picker-error-message {\n      transform: scale(0.9);\n      transform-origin: top center;\n      width: 111%;\n      margin-left: -5.5%;\n    }\n  }\n  @media screen and (max-width: 1400px) {\n    .MuiDataGrid-root,\n    .date-picker-error-message {\n      transform: scale(0.8333);\n      transform-origin: top center;\n      width: 120%;\n      margin-left: -10%;\n    }\n  }\n\n  @media screen and (max-width: 1250px) {\n    .MuiDataGrid-root {\n      transform: scale(0.8);\n      width: 125%;\n      margin-left: -12.5%;\n    }\n  }\n\n  @media screen and (max-width: 1175px) {\n    .MuiDataGrid-root {\n      transform: scale(0.75);\n      width: 133.33%;\n      margin-left: -16.67%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
